import * as tjCookie from '../tj-storage';
import { queryString } from '../utils/url-helper';
/**
 * 判断当前Cookie userId 是否是elong
 */
export function isElongUserIdByCookie() {
    var _a;
    var userId = (_a = tjCookie.getUserInfo()) === null || _a === void 0 ? void 0 : _a.userId;
    var userIdNum = Number(userId || '0');
    return userId && userIdNum >= 2.2e9 && userIdNum < 3.2e9;
}
export function getElongOpenId() {
    var elongToken = queryString('elongToken');
    if (elongToken) {
        try {
            var tokenData = JSON.parse(decodeURIComponent(elongToken));
            return tokenData.openId;
        }
        catch (error) { }
    }
}
/**
 * 包裹艺龙授权
 * @param {} param.url 标题
 * @returns {} 包裹授权的url
 */
export function wrapAuthorizeUrl(url) {
    var encodeUrl = encodeURIComponent(url);
    var elAuthorizeUrl = 'https://m.elong.com/authorize/thirdPart/login?appId=wxf5f19f298d69d701&backUrl=';
    return elAuthorizeUrl + encodeUrl;
}
